if (!window.__mMobileScrollNavInit) {
  window.__mMobileScrollNavInit = true;

  function getScrollTrack(button) {
    return button.closest(".m-mixed-layout--mobile-scroll");
  }

  function getItems(track) {
    var inner = track.querySelector(".m-mixed-layout__inner");
    return inner ? Array.from(inner.children) : [];
  }

  // Position of `item`'s left edge within the track's scrollable content,
  // independent of scroll position. Equivalent to `item.offsetLeft` when the
  // track happens to be the item's offsetParent, but unlike offsetLeft this
  // keeps working if an intervening ancestor (e.g. `.m-mixed-layout__wrapper`,
  // or a class added by a product-card app) ever becomes positioned, which
  // would otherwise silently point offsetLeft at the wrong origin.
  function contentLeft(track, trackRect, item) {
    return item.getBoundingClientRect().left - trackRect.left + track.scrollLeft;
  }

  function getScrollPadding(track) {
    // iOS Safari has a history of returning non-px values (e.g. "auto")
    // from `getComputedStyle().scrollPaddingLeft`, which silently drops the
    // intended inset via the `|| 0` fallback. Fall back to the custom
    // property the CSS itself is built from before giving up.
    var fromComputed = parseFloat(getComputedStyle(track).scrollPaddingLeft);
    if (!isNaN(fromComputed)) return fromComputed;
    var fromCustomProp = parseFloat(getComputedStyle(track).getPropertyValue("--page-padding"));
    return isNaN(fromCustomProp) ? 0 : fromCustomProp;
  }

  function scrollByStep(button, direction) {
    var track = getScrollTrack(button);
    if (!track) return;
    var items = getItems(track);
    if (!items.length) return;

    var scrollPadding = getScrollPadding(track);
    var trackRect = track.getBoundingClientRect();

    // Find the item closest to the current scroll position instead of
    // extrapolating from a fixed step size. A fixed step drifts away from
    // the real card positions by the time it reaches the last item (which
    // is what left the last card cropped instead of fully in view).
    var currentIndex = 0;
    var closestDistance = Infinity;
    items.forEach(function (item, i) {
      var distance = Math.abs(contentLeft(track, trackRect, item) - scrollPadding - track.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        currentIndex = i;
      }
    });

    var targetIndex = Math.max(0, Math.min(currentIndex + direction, items.length - 1));
    var maxScrollLeft = track.scrollWidth - track.clientWidth;
    var targetLeft = Math.max(
      0,
      Math.min(contentLeft(track, trackRect, items[targetIndex]) - scrollPadding, maxScrollLeft)
    );

    track.scrollTo({ left: targetLeft, behavior: "smooth" });
  }

  document.addEventListener("click", function (e) {
    var prevButton = e.target.closest(".m-mobile-scroll-nav .m-slider-controls__button-prev");
    var nextButton = e.target.closest(".m-mobile-scroll-nav .m-slider-controls__button-next");
    if (prevButton) {
      e.preventDefault();
      scrollByStep(prevButton, -1);
    } else if (nextButton) {
      e.preventDefault();
      scrollByStep(nextButton, 1);
    }
  });
}
